module.exports = __webpack_public_path__ + "img/part4-dIcon12.101922de.png";